import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Download = forwardRef<SVGSVGElement, SvgIconProps>(
  function Download(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M19 15.03v3.23c0 .07 0 .13-.02.18a.67.67 0 01-.65.56H5.67a.68.68 0 01-.66-.62L5 18.26v-3.24c0-.38.3-.69.66-.69.18 0 .35.08.47.2.12.13.2.3.2.5v2.58h11.35v-2.59c0-.38.3-.69.66-.69.18 0 .35.08.47.2.11.13.19.31.19.5zm-3.04-3.16l-3.38 3.16-.01.02a.82.82 0 01-.45.2l-.04.01h-.2a.8.8 0 01-.47-.23l-3.38-3.16a.72.72 0 010-1.06c.32-.3.82-.3 1.14 0l2.03 1.9V5.75c0-.41.37-.75.8-.75.23 0 .43.09.58.22.14.14.23.32.23.53v6.96l2.03-1.9c.31-.3.82-.3 1.14 0 .3.3.3.77-.02 1.06z" />
      </SvgIcon>
    )
  },
)

export default Download
